import { LegalLayout } from "@/components/LegalLayout";
import { TERMS } from "@/content/terms";

export default function TermsOfService() {
  return <LegalLayout doc={TERMS} testId="terms-page" />;
}
